var React = require('react');

function BackendNavigationCustomers (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"}));
}

BackendNavigationCustomers.displayName = "BackendNavigationCustomers";

BackendNavigationCustomers.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendNavigationCustomers;

BackendNavigationCustomers.default = BackendNavigationCustomers;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-navigation-customers.svg
// module id = 992
// module chunks = 0